import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Starfield } from "@/components/Starfield";
import Landing from "@/pages/Landing";
import Universe from "@/pages/Universe";
import PlanetDetail from "@/pages/PlanetDetail";
import Library from "@/pages/Library";
import Feed from "@/pages/Feed";
import SharedPlanet from "@/pages/SharedPlanet";

function RequireAuth({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <span className="label-mono animate-pulse">Establishing uplink…</span>
      </div>
    );
  }
  if (user === false) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App grain">
      <Starfield />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/universe" element={<RequireAuth><Universe /></RequireAuth>} />
            <Route path="/planet/:id" element={<RequireAuth><PlanetDetail /></RequireAuth>} />
            <Route path="/library" element={<RequireAuth><Library /></RequireAuth>} />
            <Route path="/feed" element={<RequireAuth><Feed /></RequireAuth>} />
            <Route path="/p/:token" element={<SharedPlanet />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: { background: "rgba(5,7,13,0.92)", border: "1px solid rgba(0,240,255,0.3)", color: "#F1F5F9", backdropFilter: "blur(16px)" },
        }}
      />
    </div>
  );
}

export default App;
